module.exports = __webpack_public_path__ + "3b3da36fb9c5b6d065c8707eb7e680c7.svg";